// extracted by mini-css-extract-plugin
module.exports = {"orderBase":"OrderBase_style_orderBase__-PwzK","baseLay":"OrderBase_style_baseLay__1Jyod"};